export default "__VITE_ASSET__WU8N30BA__"